import { dsl } from '@wix/yoshi-serverless/wrap';

export const ssr = dsl({
          functionName: 'ssr',
          fileName: 'api/ssr.api',
        });